<template>
  <b-container fluid>
    <page-title icon="fas fa-truck-moving">
      <translate>Carriers</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" :to="{name: 'CarriersCreate'}">
          <font-awesome-icon icon="plus-circle" />
          <translate>New Carrier</translate>
        </b-button>
      </template>
    </page-title>
    <api-list type="carriers" :model="models.carriers" :quick-filters="quickFiltersSetup.companies" :pre-filters="[['relationship', 'eq', 'provider']]" />
  </b-container>
</template>
<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'CarrierList',
  title() {
    return this.$gettext('Carriers')
  },
  components: {
    ApiList
  }
}
</script>
